import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "w-350",
  style: {"width":"550px"}
}, [
  /*#__PURE__*/_createElementVNode("h4", { style: {"margin-bottom":"30px"} }, "Puffin feature release and downtime notification"),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Today data moving, that is sent from browser to server via SSL is secured. This is how we solved securing data that moves."),
    /*#__PURE__*/_createElementVNode("li", null, "Data at rest is stored to Postgre SQL database server. On Thu Feb 1st 2am PST Puffin will be unavailable for two hours. This is required to make the database encrypted and this is how we will keep data at rest secure going forward.")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_connection_status_toast = _resolveComponent("connection-status-toast")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_the_modal = _resolveComponent("the-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_notifications, { position: "bottom right" }),
    _createVNode(_component_connection_status_toast),
    _createVNode(_component_router_view),
    _createVNode(_component_the_modal, { "is-visible": _ctx.shouldShowUpdateModal }, {
      content: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_base_button, {
          class: "mx-1",
          variant: "base",
          onClick: _ctx.onConfirmUpdateModal
        }, {
          default: _withCtx(() => [
            _createTextVNode("I Understand")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["is-visible"])
  ]))
}